import type { FC } from 'react';

import type { BoxProps } from '@mui/material/Box';
import Box from '@mui/material/Box';

export const CenterBox: FC<BoxProps> = ({ children, sx, ...rest }) => (
  <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', ...sx }} {...rest}>
    {children}
  </Box>
);
